import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useHistory, useLocation } from "react-router-dom";
import { Auth, API } from "aws-amplify";
import LoaderButton from "../components/LoaderButton";
import { useAppContext } from "../libs/contextLib";
import { useFormFields } from "../libs/hooksLib";
import { onError } from "../libs/errorLib";
import { checkYMD, validateSimpleDateFormat } from "../libs/utilsLib";
import PrivacyPolicyForm from "./PrivacyPolicyForm";
import libmime from "libmime";
import AdministrativeAttrsForm from "./AdministrativeAttrsForm";
import AdministrativeAttrsConfirm from "./AdministrativeAttrsConfirm";
import RegistrationInfoForm from "./RegistrationInfoForm";
import RegistrationInfoConfirm from "./RegistrationInfoConfirm";
import AffiliationInfoForm from "./AffiliationInfoForm";
import AffiliationInfoConfirm from "./AffiliationInfoConfirm";
import HomeInfoConfirm from "./HomeInfoConfirm";
import BasicDomainInfoConfirm from "./BasicDomainInfoConfirm";
import HomeInfoForm from "./HomeInfoForm";
import BasicDomainInfoForm from "./BasicDomainInfoForm";
import AcademicHistoryInfoForm from "./AcademicHistoryInfoForm";
import AcademicHistoryInfoConfirm from "./AcademicHistoryInfoConfirm";
import CertificationInfoForm from "./CertificationInfoForm";
import CertificationInfoConfirm from "./CertificationInfoConfirm";
import CertificationInfo2FormV2 from "./CertificationInfo2FormV2";
import CertificationInfo2ConfirmV2 from "./CertificationInfo2ConfirmV2";
import RecommendersInfoConfirm from "./RecommendersInfoConfirm";
import RecommendersInfo2Confirm from "./RecommendersInfo2Confirm";
import RecommendersInfoForm from "./RecommendersInfoForm";
import RecommendersInfo2Form from "./RecommendersInfo2Form";
import OthersInfoForm from "./OthersInfoForm";
import OthersInfoConfirm from "./OthersInfoConfirm";
import ScrollToTop from 'react-router-scroll-top';
import MembersInfo from "./MembersInfo";
import config from '../config';
import "./Signup.css";

export default function Signup(props) {
  const [refreshCount, setRefreshCount] = useState(0);
  const search = useLocation().search;
  const opt = new URLSearchParams(search).get('opt'); // Opration Type
  const mt = new URLSearchParams(search).get('mt');  // Member Type
  const [opType, setOpType] = useState(opt ? opt : 1);
  useEffect(() => {
    console.log('useEffect called...');
    console.log(today());
    window.scrollTo(0, 0);
   if (refreshCount > 0) return;
    const onLoad = async () => {
      if (isAuthenticated && isAdmin) {
        setPage('input');        
      }
      if (opType == 1) 
        setMemberTypeLabel('正会員申込み（医師・歯科医師用）');
      else if (opType == 10)
        setMemberTypeLabel('学生会員申込み');
      else
        setMemberTypeLabel('准会員申込み');
      console.log('onLoad called...');
      updateValidationMessages();
      const anonymousUser = await Auth.currentCredentials();
      console.log('opType = ' + opType);
    };
    onLoad();
  },[refreshCount]);

  const today = () => {
    let today = new Date();
 
    let year = today.getFullYear();
    let month = today.getMonth() + 1;
    month = month.toString().padStart(2, '0');
    let date = today.getDate();
    date = date.toString().padStart(2, '0');
 
    return (year + '/' + month + '/' + date);
  };

  const getCertNoErrorMsg = (checkId, value) => {
    if (!document.getElementById(checkId)) return '';
    const isck = document.getElementById(checkId).checked;
    if (!value && isck) {
      const mes = '認定資格番号を入力してください。';
      return mes;
    }
    return '';
  };

  const getCertDateErrorMsg = (checkId, value) => {
      if (!document.getElementById(checkId)) return '';
      const isck = document.getElementById(checkId).checked;
      if (isck) {
        if (!value) {
          const mes = '取得年月日を入力してください。';
          console.log(mes);
          return mes;
	}
        const arr = value.split('/');
        let mes = '2021/06/07 の形式で入力してください。';
        if (arr.length != 3) return mes;
        if (!(arr[0].length == 4 && arr[1].length == 2 && arr[2].length == 2)) {
          return mes;
        }	      
      }
      return '';
  };

  const [fields, messages, handleFieldChange, doValidation] = useFormFields({
    postAndCommittee: "",
    committeeActiveHistories: "",
    termOfRepresentative: "",
    termOfDirective: "",
    academicAwards: "",
    accountPayable: "",
    transitionDate: "",
    shipments: "",
    classRemarks: "",
    remarks: "",
    loginId: "",
    password: "",
    confirmPassword: "",
    confirmationCode: "",
    admissionRequestDate: "",
    admissionDate: "",
    familyName: "",
    givenName: "",
    familyNameKana: "",
    givenNameKana: "",
//    gender: "0",
    birthDate: "",
    certifiedDate: "",
    certifiedNo0: "",
    certifiedNo1: "",
    certifiedNo2: "",
    certifiedNo3: "",
    certifiedNo4: "",
    certifiedNo5: "",
    certifiedNo6: "",
    certifiedNo7: "",
    certifiedNo8: "",
    certifiedNo9: "",
    certifiedNo10: "",
    certifiedNo12: "",
    certified12Text: "",
    certifiedNo13: "",
    certifiedNo14: "",
    certifiedDate0: "",
    certifiedDate1: "",
    certifiedDate2: "",
    certifiedDate3: "",
    certifiedDate4: "",
    certifiedDate5: "",
    certifiedDate6: "",
    certifiedDate7: "",
    certifiedDate8: "",
    certifiedDate9: "",
    certifiedDate10: "",
    certifiedDate12: "",
    certifiedDate13: "",
    certifiedDate14: "",
    acquiredDate: "",
    affiliationName: "",
    affiliationDepertment: "",
    affiliationPosition: "",
    affiliationOccupation: "",
    affiliationPostalCode: "",
    affiliationAddress: "",
    affiliationAddressKana: "",
    affiliationTel: "",
    affiliationFax: "",
    affiliationEmail: "",
    affiliationEmailConfirmation: "",
    homePostalCode: "",
    homeAddress: "",
    homeAddressKana: "",
    homeTel: "",
    homeFax: "",
    basicDomain: "",
    basicDomainOther: "",
//    expertDomain: "",
    expertDomainOther: "",
    academicHistory: "",
    classOfYear: "",
    expectedToGraduateOfYear: "",
    medicalRegistrationNumber: "",
//    acquisitionYear: "",
//    acquisitionMonth: "",
//    acquisitionDay: "",
    degree: "",
    certificationNumber: "",
    recommender: "",
    reasonForRecommend: "",
    recommender1: "",
    reasonForRecommend1: "",
    recommender2: "",
    reasonForRecommend2: "",
    biography: "",
    activitiesForTheField: "",
    papersAndPerformanceHistory: "",
    motivationsAndAspirations: "",
  },
  {
    postAndCommittee: {n:"", f: (value) => { console.log(value); return ''}},
    committeeActiveHistories: {n:"", f: (value) => { console.log(value); return ''}},
    termOfRepresentative: {n:"", f: (value) => { console.log(value); return ''}},
    termOfDirective: {n:"", f: (value) => { 
      console.log(value);
      if (value) { return validateSimpleDateFormat(value);}
      return '';
    }},
    academicAwards: {n:"", f: (value) => { console.log(value); return ''}},
    accountPayable: {n:"", f: (value) => { console.log(value); return ''}},
    transitionDate: {n:"", f: (value) => {
      console.log(value);
      if (value) { return validateSimpleDateFormat(value);}
      return '';
    }},
    shipments: {n:"", f: (value) => { console.log(value); return '' }},
    classRemarks: {n:"", f: (value) => { console.log(value); return '' }},
    remarks: {n:"", f: (value) => { console.log(value); return '' }},
    loginId: {n:"", f: (value) => {
	console.log('loginid ...' + opType);
      if (value || 0 != opType)
        return ''; 
      else { 
        console.log('setRef.....'); 
        //setRefreshCount(refreshCount+1); 
        return '会員番号は必須です';
      }
    }},
    password: {n:"", f: (value) => { console.log(value); return '' }},
    confirmPassword: {n:"", f: (value) => { console.log(value); return ''}},
    confirmationCode: {n:"", f: (value) => { console.log(value); return ''}},
    admissionRequestDate: {n:"", f: (value) => { 
        console.log(value);
        if (value) { return validateSimpleDateFormat(value);}
        return '';
    }},
    admissionDate: {n:"", f: (value) => { 
        console.log(value);
        if (value) { return validateSimpleDateFormat(value);}
        return '';
    }},
    familyName: {n:"", f: (value) => {
        console.log('familyName...');
        console.log(value);
        console.log(fields.familyName);
        if (!value) 
          return '氏名(姓)を入力してください。';
        return '';
    }},
    givenName: {n:"", f: (value) => {
      console.log(value);
      if (!value) 
        return '氏名(名)を入力してください。';
      return '';
    }},
    familyNameKana: {n:"", f: (value) => {
      console.log(value);
      if (!value) 
        return '氏名(セイ)を入力してください。';
      return '';
    }},
    givenNameKana: {n:"", f: (value) => {
      console.log(value);
      if (!value) 
        return '氏名(メイ)を入力してください。';
      return '';
    }},
//    gender: {n:"", f: (value) => {
//      if (value == 0) 
//        return '性別を指定してください。';
//      return '';
//    }},
    birthDate: {n:"", f: (value) => {
      console.log('birth date...');
      if (!value)
        return '生年月日を入力してください。';
      const ar = value.split('/');
      console.log(ar.length);
      if (ar.length == 3 && checkYMD(ar[0], ar[1], ar[2]))
        return '';
      return '2021/03/04 の形式で入力してください。';
    }},
    certifiedDate: {n:"", f: (value) => {
      if (opType != 1) return '';
      if (!value)
        return '取得年月日を入力してください。';
      const ar = value.split('/');
      console.log(ar.length);
      if (ar.length == 3 && checkYMD(ar[0], ar[1], ar[2]))
        return '';
      return '2021/03/04 の形式で入力してください。';
    }},
    certifiedNo0: {n:"", f: (value) => {
      return getCertNoErrorMsg('cert2Checks0', value);
    }},
    certifiedNo1: {n:"", f: (value) => {
      return getCertNoErrorMsg('cert2Checks1', value);
    }},
    certifiedNo2: {n:"", f: (value) => {
      return getCertNoErrorMsg('cert2Checks2', value);
    }},
    certifiedNo3: {n:"", f: (value) => {
      return getCertNoErrorMsg('cert2Checks3', value);
    }},
    certifiedNo4: {n:"", f: (value) => {
      return getCertNoErrorMsg('cert2Checks4', value);
    }},
    certifiedNo5: {n:"", f: (value) => {
      return getCertNoErrorMsg('cert2Checks5', value);
    }},
    certifiedNo6: {n:"", f: (value) => {
      return getCertNoErrorMsg('cert2Checks6', value);
    }},
    certifiedNo7: {n:"", f: (value) => {
      return getCertNoErrorMsg('cert2Checks7', value);
    }},
    certifiedNo8: {n:"", f: (value) => {
      return getCertNoErrorMsg('cert2Checks8', value);
    }},
    certifiedNo9: {n:"", f: (value) => {
      return getCertNoErrorMsg('cert2Checks9', value);
    }},
    certifiedNo10: {n:"", f: (value) => {
      return getCertNoErrorMsg('cert2Checks10', value);
    }},
    certifiedNo12: {n:"", f: (value) => {
      return getCertNoErrorMsg('cert2Checks12', value);
    }},
    certifiedNo13: {n:"", f: (value) => {
      return getCertNoErrorMsg('cert2Checks13', value);
    }},
    certifiedNo14: {n:"", f: (value) => {
      return getCertNoErrorMsg('cert2Checks14', value);
    }},
    certified12Text: {n:"", f: (value) => {
      if (!document.getElementById('cert2Checks12')) return '';
      const isck = document.getElementById('cert2Checks12').checked;
      if (!value && isck) {
        const mes = 'その他の資格・身分の名称を入力してください。';
        return mes;
      } else
        return "";
    }},
    certifiedDate0: {n:"", f: (value) => {
      return getCertDateErrorMsg('cert2Checks0', value);
    }},
    certifiedDate1: {n:"", f: (value) => {
      return getCertDateErrorMsg('cert2Checks1', value);
    }},
    certifiedDate2: {n:"", f: (value) => {
      return getCertDateErrorMsg('cert2Checks2', value);
    }},
    certifiedDate3: {n:"", f: (value) => {
      return getCertDateErrorMsg('cert2Checks3', value);
    }},
    certifiedDate4: {n:"", f: (value) => {
      return getCertDateErrorMsg('cert1Checks4', value);
    }},
    certifiedDate5: {n:"", f: (value) => {
      return getCertDateErrorMsg('cert2Checks5', value);
    }},
    certifiedDate6: {n:"", f: (value) => {
      return getCertDateErrorMsg('cert2Checks6', value);
    }},
    certifiedDate7: {n:"", f: (value) => {
      return getCertDateErrorMsg('cert2Checks7', value);
    }},
    certifiedDate8: {n:"", f: (value) => {
      return getCertDateErrorMsg('cert2Checks8', value);
    }},
    certifiedDate9: {n:"", f: (value) => {
      return getCertDateErrorMsg('cert2Checks9', value);
    }},
    certifiedDate10: {n:"", f: (value) => {
      return getCertDateErrorMsg('cert2Checks10', value);
    }},
    certifiedDate12: {n:"", f: (value) => {
      return getCertDateErrorMsg('cert2Checks12', value);
    }},
    certifiedDate13: {n:"", f: (value) => {
      return getCertDateErrorMsg('cert2Checks13', value);
    }},
    certifiedDate14: {n:"", f: (value) => {
      return getCertDateErrorMsg('cert2Checks14', value);
    }},
    acquiredDate: {n:"", f: (value) => {
      if (mt == 4) return '';
      if (!value)
        return '取得年月日を入力してください。';
      const ar = value.split('/');
      console.log(ar.length);
      if (ar.length == 3 && checkYMD(ar[0], ar[1], ar[2]))
        return '';
      return '2021/03/04 の形式で入力してください。';
    }},
    affiliationName: {n:"", f: (value) => {
      console.log(value);
      if (!value) return '名称を入力してください。';
      return '';
    }},
//    affiliationName: {n:"", f: (value) => {
    affiliationDepertment: {n:"", f: (value) => {
      console.log(value);
      if (!value) return '部署を入力してください。';
      return '';
    }},
    affiliationPosition: {n:"", f: (value) => {
      console.log(value);
      return '';
    }}, 
    affiliationOccupation: {n:"", f: (value) => {
      console.log(value);
      if (opt != 10 && !value) return '職種を入力してください。';
      return '';
    }}, 
    affiliationPostalCode: {n:"", f: (value) => {
      console.log(value);
      if (!value) return '郵便番号を入力してください。';
      const arr = value.split('-');
      if (arr.length != 2 || arr[0].match(/[^0-9]/) != null || arr[1].match(/[^0-9]/) != null ||  arr[0].length != 3 || arr[1].length != 4)  return '半角 123-4567 の形式で入力してください。';
      return '';
    }},
    affiliationAddress: {n:"", f: (value) => {
      console.log(value);
      if (!value) return '所在地を入力してください。';
      return '';
    }},
    affiliationAddressKana: {n:"", f: (value) => {
      console.log(value);
      if (!value) return '所在地（フリガナ）を入力してください。';
      return '';
    }},
    affiliationTel: {n:"", f: (value) => {
      console.log(value);
      if (!value) return '電話番号を入力してください。';
      const arr = value.split('-');
      if ((value.match(/[^0-9\-]/) != null) || arr.length != 3 || arr[0].length < 2 || arr[1].length < 2 || arr[2].length < 4)  return '半角 03-1234-5678 の形式で入力してください。';
      return '';
    }},
    affiliationFax: {n:"", f: (value) => {
      console.log(value);
      if (value.length > 0) {
        const arr = value.split('-');
        if ((value.match(/[^0-9\-]/) != null) || arr.length != 3 || arr[0].length < 2 || arr[1].length < 2 || arr[2].length < 4)  return '半角 03-1234-5678 の形式で入力してください。';
      }
      return ''
    }},
    affiliationEmail: {n:"", f: (value) => {
      console.log(value);
      if (!value) return 'Emailを入力してください。';
      if (value.match(/^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/) == null) return 'Email アドレスは半角で入力してください。';
      const arr = value.split('@');
      if (arr.length != 2 || arr[0].length < 1 || arr[1].length < 1 || arr[1].split('.').length < 2)  return 'Email アドレスの形式が不正です。';
      return '';
    }},
    affiliationEmailConfirmation: {n:"", f: (value) => {
      const org = document.getElementById('affiliationEmail').value;
      console.log(value);
      
      if (!value) return 'Email（確認用）を入力してください。';
      if (value.match(/^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/) == null) return 'Email アドレスは半角で入力してください。';
      const arr = value.split('@');
      if (arr.length != 2 || arr[0].length < 1 || arr[1].length < 1 || arr[1].split('.').length < 2)  return 'Email アドレスの形式が不正です。';
      if (org == value) setEmailMismatchMessage('');
      return '';
    }},
    homePostalCode: {n:"", f: (value) => {
      console.log(value);
      if (!value) return '郵便番号を入力してください。';
      const arr = value.split('-');
      if (arr.length != 2 || arr[0].match(/[^0-9]/) != null || arr[1].match(/[^0-9]/) != null ||  arr[0].length != 3 || arr[1].length != 4)  return '半角 123-4567 の形式で入力してください。';
      return '';
    }},
    homeAddress: {n:"", f: (value) => {
      console.log(value);
      if (!value) return '現住所を入力してください。';
      return '';
    }},
    homeAddressKana: {n:"", f: (value) => {
      console.log(value);
      if (!value) return '現住所（フリガナ）を入力してください。';
      return '';
    }},
    homeTel: {n:"", f: (value) => {
      console.log(value);
      if (!value) return '電話番号を入力してください。';
      const arr = value.split('-');
      if ((value.match(/[^0-9\-]/) != null) || arr.length != 3 || arr[0].length < 2 || arr[1].length < 2 || arr[2].length < 4)  return '半角 03-1234-5678 の形式で入力してください。';
      return '';
    }},
    homeFax: {n:"", f: (value) => {
      console.log(value);
      if (value.length > 0) {
        const arr = value.split('-');
        if ((value.match(/[^0-9\-]/) != null) || arr.length != 3 || arr[0].length < 2 || arr[1].length < 2 || arr[2].length < 4)  return '半角 03-1234-5678 の形式で入力してください。';
      }
      return '';
    }},
    basicDomain: {n:"", f: (value) => {
      console.log(value);
      if (value != 22) setBasicDomainOtherMessage('');
      if ((opt != 2 || opt != 10) && !value) return 'ベーシック領域を選択してください。';
      return '';
    }},
    basicDomainOther: {n:"", f: (value) => {
      if (opt == 2 || opt == 10) return '';
      var el = document.getElementById("basicDomain");
      var sl = el.value;
      if (!el || sl != 22) return '';
      console.log('selected basic domain......');
      console.log(sl);
      if (sl == "22" && !value) return 'その他を入力してください。';

      console.log('selected basic domain......!');
      setBasicDomainOtherMessage('');
      return '';
    }},
//    expertDomain: {n:"", f: (value) => {
//      console.log(value);
//      if (opt != 2 && !value) return 'エキスパート領域を選択してください。';
//      return '';
//    }},
    expertDomainOther: {n:"", f: (value) => {
      console.log(value);
      if (value) setExpertDomainOtherMessage('');
      return '';
    }},
    academicHistory: {n:"", f: (value) => {
      console.log(value);
      if (!value) return '最終学歴を入力してください。';
      return '';
    }},
    classOfYear: {n:"", f: (value) => {
      console.log(value);

      if (value) {
        console.log('check digit: ' + value.match(/[^0-9]/));
      }
      
      if (!(value && value.length == 4) ) return '卒業年度を西暦で入力してください。';
      if (value.match(/[^0-9]/) != null) return '卒業年度は半角数字で入力してください。';
      return '';
    }},
    expectedToGraduateOfYear: {n:"", f: (value) => {
      console.log(value);

      if (value) {
        console.log('check digit: ' + value.match(/[^0-9]/));
      }

      if (opt == 10 && !(value && value.length == 4) ) return '卒業予定を西暦で入力してください。';
      if (opt == 10 && value.match(/[^0-9]/) != null) return '卒業予定は半角数字で入力してください。';
      return '';
    }},
    medicalRegistrationNumber: {n:"", f: (value) => {
//      console.log(value);
      if (opt != 2 && !value) return '医籍登録番号を入力してください。';
      return '';
    }},
//    acquisitionYear: {n:"", f: (value) => { console.log(value); return '' }},
//    acquisitionMonth: {n:"", f: (value) => { console.log(value); return '' }},
//    acquisitionDay: {n:"", f: (value) => { console.log(value); return '' }},
    degree: {n:"", f: (value) => {
      console.log(value);
      if (opt != 1 && !value) return '学位を入力してください。';
      return '';
    }},
    certificationNumber: {n:"", f: (value) => {
      console.log(value);
      if (!value &&  1 == opType) return '取得資格番号を入力してください。';
      return '';
    }},
    recommender: {n:"", f: (value) => {
      console.log(value);
      if (opt != 1 && !value) return '推薦者を入力してください。';
      return '';
    }},
    reasonForRecommend: {n:"", f: (value) => { 
      console.log(value);
      if (opt != 1 && !value) return '推薦理由を入力してください。';
      return '';
    }},
    recommender1: {n:"", f: (value) => { console.log(value); return '' }},
    reasonForRecommend1: {n:"", f: (value) => { console.log(value); return '' }},
    recommender2: {n:"", f: (value) => { console.log(value); return '' }},
    reasonForRecommend2: {n:"", f: (value) => { console.log(value); return '' }},
    biography: {n:"", f: (value) => {
      console.log(value);
      if (opt != 1 && !value) return '略歴を入力してください。';
      return '';
    }},
    activitiesForTheField: {n:"", f: (value) => {
      console.log(value);
      if (opt != 1 && !value) return 'スポーツ現場に関わる活動を入力してください。';
      return '';
    }},
    papersAndPerformanceHistory: {n:"", f: (value) => {
      console.log(value);
      if (opt != 1 && !value) return '原著論文・学会発表歴を入力してください。';
      return '';
    }},
    motivationsAndAspirations: {n:"", f: (value) => {
      console.log(value);
      if (opt != 1 && !value) return '入会希望の動機と抱負を入力してください。';
      return '';
    }},
 });

  // memStatus (Member Status) radio
  const [memStatus, setMemStatus] = useState(1); // 1: Request
  // memType (Member Type) radio
  const [memType, setMemType] = useState(mt ? mt : 1);
  // memClass (Member Classification) radio
  const [memClass, setMemClass] = useState(0);
  // memPaymentMethod radio
  const [memPaymentMethod, setMemPaymentMethod] = useState(0);
  // memPost (Member Post) checkbox
  const [memPost, setMemPost] = useState([0,0,0,0,0]);
  // memCommittee (Member Committee) checkbox
  const [memCommittee, setMemCommittee] = useState([0,0,0,0,0,0,0,0,0,0]);
  // memRepresentative (Member Representative) checkbox
  const [memRepresentative, setMemRepresentative] = useState([0]);

  // gender radio
  const [gender, setGender] = useState(0);
  const [genderMessage, setGenderMessage] = useState('');
  // destination radio
  const [destination, setDestination] = useState(0);
  const [destinationMessage, setDestinationMessage] = useState('');
  // graduate radio
  const [graduate, setGraduate] = useState(0);
  const [graduateMessage, setGraduateMessage] = useState('');

  // primary games supported radio
  const [primaryGames, setPrimaryGames] = useState(0);
  const [primaryGamesMessage, setPrimaryGamesMessage] = useState('');

  // expert domain checkbox
  const [expertDomainChecks, setExpertDomainChecks] = useState([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]);

  // cert1 checkbox
  const [cert1Checks, setCert1Checks] = useState([0,0,0,0,0,0]);
  // cert2 checkbox
  const [cert2Checks, setCert2Checks] = useState([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]);

  const [emailMismatchMessage, setEmailMismatchMessage] = useState('');
  const [basicDomainOtherMessage, setBasicDomainOtherMessage] = useState('');
  const [expertDomainOtherMessage, setExpertDomainOtherMessage] = useState('');
  const [cert1ChecksMessage, setCert1ChecksMessage] = useState('');
  const [cert2ChecksMessage, setCert2ChecksMessage] = useState('');
  const [expertDomainChecksMessage, setExpertDomainChecksMessage] = useState('');

  const history = useHistory();
  const [newUser, setNewUser] = useState(null);
  const { isAuthenticated, userHasAuthenticated, isAdmin } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState("pp"); // Privacy Policy as default
  const [memberTypeLabel, setMemberTypeLabel] = useState("");

  const vldNamesByHand = {
    "gender": genderMessage,
    "destination": destinationMessage,
    "affiliationEmailConfirmation": emailMismatchMessage,
    "expertDomainChecks19": expertDomainChecksMessage,
    "primaryGame13": primaryGamesMessage,
    "graduate": graduateMessage,
    "cert1Checks0": cert1ChecksMessage,
    "cert2Checks11": cert2ChecksMessage,
  };

  function updateValidationMessages() {
    console.log('updateValidationMessages...');
      for(let key in messages) {
	  console.log(key + ' = ' + messages[key].n);
          const  mElmt = document.getElementById(key+'Message');
          if (mElmt)
            mElmt.textContent = messages[key].n;

      }
  }
/*
  function checkYMD(y,m,d) {
    const r = (y.length == 2 && y.match(/[^0-9]/) == null) && (m.length == 2 && m.match(/[^0-9]/) == null) && (d.length == 2 && d.match(/[^0-9]/) == null);
    return r;
  }
*/
  function validateForm() {
//    console.log(messages);
    let b = doValidation();
    console.log('doValidation return: ' + b);
    let c = (0 == gender);
    if (b) b = !c;
    let m = c ? '性別を選択してください' : '' ;
    setGenderMessage(m);

    console.log(m);

    c = (0 == destination);
    if (b) b = !c;
    m = c ? '送付先を選択してください' : '' ;
    setDestinationMessage(m);
    console.log(m);

    if (fields.affiliationEmailConfirmation != fields.affiliationEmail) {
      c = true
      if (b) b = !c;
      m = c ? 'Email（確認用）が一致していません。' : '' ;
      setEmailMismatchMessage(m);
      console.log(m);
    }

    console.log('basicDomain....' + fields.basicDomain);
    if (19 == fields.basicDomain) {
      c = (1 > fields.basicDomainOther.length);
      if (b) b = !c;
      m = c ? 'その他の内容を入力してください' : '' ;
      setBasicDomainOtherMessage(m);
    } else {
      setBasicDomainOtherMessage('');
    }

    if (19 == fields.expertDomain) {
      c = (1 > fields.expertDomainOther.length);
      if (b) b = !c;
      m = c ? 'その他の内容を入力してください' : '' ;
      setExpertDomainOtherMessage(m);
    }
    c = (0 == graduate);
    if (b) b = !c;
    m = (c && mt != 14) ? '大学/大学院を指定してください。' : ''; 
    setGraduateMessage(m);
    console.log(m);

    c = (
      (parseInt(expertDomainChecks[0]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[1]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[2]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[3]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[4]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[5]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[6]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[7]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[8]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[9]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[10]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[11]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[12]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[13]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[14]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[15]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[16]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[17]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[18]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[19]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[20]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[21]) > 0 ? 1 : 0)
    );
    if (b && 2 != opType) b = (c > 0 && c < 4);
    m = c == 0 ? 'エクスパート領域を一つ以上選択してください。' : ( c > 3 ? 'エクスパート領域の選択は３つまでです。' : ''); 
    setExpertDomainChecksMessage(m);
    console.log(m);
    console.log(b + ' 1.5');

    console.log(primaryGames);
    console.log(opType);
    c = (0 == primaryGames);
    if (b && 2 != opType) b = !c;
    m = c ? '主としてサポートしている競技の分類を指定してください。' : ''; 
    console.log(m);
    setPrimaryGamesMessage(m);
    console.log(m);
    console.log(b + ' 1.6');

    c = (
      0 == cert1Checks[0] &&
      0 == cert1Checks[1] &&
      0 == cert1Checks[2] &&
      0 == cert1Checks[3] &&
      0 == cert1Checks[4] &&
      0 == cert1Checks[5]);
    if (b && 2 != opType) b = !c;
    m = c ? '取得スポーツ医資格を一つ以上選択してください。' : ''; 
    setCert1ChecksMessage(m);
    console.log(m);
    console.log(b + '6');

    c = (
      0 == cert2Checks[0] && 
      0 == cert2Checks[1] && 
      0 == cert2Checks[2] && 
      0 == cert2Checks[3] && 
      0 == cert2Checks[4] && 
      0 == cert2Checks[5] && 
      0 == cert2Checks[6] && 
      0 == cert2Checks[7] && 
      0 == cert2Checks[8] && 
      0 == cert2Checks[9] && 
      0 == cert2Checks[10] && 
      0 == cert2Checks[11] &&
      0 == cert2Checks[13] &&
      0 == cert2Checks[14] &&
      0 == cert2Checks[12]);
    if (b && 1 != opType) b = !c;
    m = c ? '資格・身分を一つ以上選択してください。' : ''; 
    setCert2ChecksMessage(m);
    console.log(m);
    console.log(b + '7');

    return b; 
  }

  function validateConfirmationForm() {
    //return fields.confirmationCode.length > 0;
    return true;
  }

  function valocator(name, value) {
  }

  function handleExpertDomainChecksChange(event) {
    const n = event.target.name;
    console.log(event.target);
    console.log(n.substring('expertDomainChecks'.length));
    const i = n.substring('expertDomainChecks'.length);
    let chs = JSON.parse(JSON.stringify(expertDomainChecks));
    chs[i] = event.target.checked ? parseInt(event.target.value) : 0;
    console.log(chs);
    setExpertDomainChecks(chs);

    const c = (
      (parseInt(chs[0]) > 0 ? 1 : 0) +
      (parseInt(chs[1]) > 0 ? 1 : 0) +
      (parseInt(chs[2]) > 0 ? 1 : 0) +
      (parseInt(chs[3]) > 0 ? 1 : 0) +
      (parseInt(chs[4]) > 0 ? 1 : 0) +
      (parseInt(chs[5]) > 0 ? 1 : 0) +
      (parseInt(chs[6]) > 0 ? 1 : 0) +
      (parseInt(chs[7]) > 0 ? 1 : 0) +
      (parseInt(chs[8]) > 0 ? 1 : 0) +
      (parseInt(chs[9]) > 0 ? 1 : 0) +
      (parseInt(chs[10]) > 0 ? 1 : 0) +
      (parseInt(chs[11]) > 0 ? 1 : 0) +
      (parseInt(chs[12]) > 0 ? 1 : 0) +
      (parseInt(chs[13]) > 0 ? 1 : 0) +
      (parseInt(chs[14]) > 0 ? 1 : 0) +
      (parseInt(chs[15]) > 0 ? 1 : 0) +
      (parseInt(chs[16]) > 0 ? 1 : 0) +
      (parseInt(chs[17]) > 0 ? 1 : 0) +
      (parseInt(chs[18]) > 0 ? 1 : 0) +
      (parseInt(chs[19]) > 0 ? 1 : 0) +
      (parseInt(chs[20]) > 0 ? 1 : 0) +
      (parseInt(chs[21]) > 0 ? 1 : 0)
    );
    const m = c == 0 ? 'エクスパート領域を一つ以上選択してください。' : ( c > 3 ? 'エクスパート領域の選択は３つまでです。' : ''); 
    setExpertDomainChecksMessage(m);
  }

  function handleCert1ChecksChange(event) {
    const n = event.target.name;
    console.log(n.substring('cert1Checks'.length));
    const i = parseInt(n.substring('cert1Checks'.length));
    let chs = JSON.parse(JSON.stringify(cert1Checks));
    chs[i] = event.target.checked ? parseInt(event.target.value) : 0;
    console.log(chs);
    setCert1Checks(chs);

    const c = (
      0 == chs[0] &&
      0 == chs[1] &&
      0 == chs[2] &&
      0 == chs[3] &&
      0 == chs[4] &&
      0 == chs[5] &&
      0 == chs[6] &&
      0 == chs[7] &&
      0 == chs[8] &&
      0 == chs[9] &&
      0 == chs[10] &&
      0 == chs[11] &&
      0 == chs[12]
    );
    const m = c ? '資格・身分を一つ以上選択してください。' : ''; 
    setCert1ChecksMessage(m);
  }

 function handleCert2ChecksChange(event) {
    const n = event.target.name;
    console.log(n.substring('cert2Checks'.length));
    const i = parseInt(n.substring('cert2Checks'.length));
    let chs = JSON.parse(JSON.stringify(cert2Checks));
    chs[i] = event.target.checked ? parseInt(event.target.value) : 0;
    console.log(chs);
    setCert2Checks(chs);
    const c = (
      0 == chs[0] && 
      0 == chs[1] && 
      0 == chs[2] && 
      0 == chs[3] && 
      0 == chs[4] && 
      0 == chs[5] && 
      0 == chs[6] && 
      0 == chs[7] && 
      0 == chs[8] && 
      0 == chs[9] && 
      0 == chs[10] && 
      0 == chs[11] && 
      0 == chs[12]);
    const m = c ? '資格・身分を一つ以上選択してください。' : ''; 
    setCert2ChecksMessage(m);
  }

  function handleMemPostChange(event) {
    const n = event.target.name;
    const i = parseInt(n.substring(n.length - 1));
    let chs = JSON.parse(JSON.stringify(memPost));
    chs[i] = event.target.checked ? 1 : 0;
    setMemPost(chs);
  }

  function handleSetGender(event) {
      console.log('handleSetGender...');
      setGender(event.target.value);
      setGenderMessage('');
  }

  function handleSetDestination(event) {
      console.log('handleSetDestination...');
      setDestination(event.target.value);
      setDestinationMessage('');
  }

  function handleSetGraduate(event) {
      console.log('handleSetGraduate...');
      setGraduate(event.target.value);
      setGraduateMessage('');
  }

  function handlePrimaryGamesChange(event) {
      console.log('handlePrimaryGamesChange...');
      setPrimaryGames(event.target.value);
      setPrimaryGamesMessage('');
  }
  
  function handleMemCommitteeChange(event) {
    const n = event.target.name;
//    console.log(n.substring('memCommittee'.length));
    const i = parseInt(n.substring('memCommittee'.length));
    let chs = JSON.parse(JSON.stringify(memCommittee));
    chs[i] = event.target.checked ? 1 : 0;
//    console.log(chs);
    setMemCommittee(chs);
  }

 function handleMemRepresentativeChange(event) {
    const n = event.target.name;
//    console.log(n.substring('memCommittee'.length));
    const i = parseInt(n.substring('memRepresentative'.length));
    let chs = JSON.parse(JSON.stringify(memRepresentative));
    chs[i] = event.target.checked ? 1 : 0;
//    console.log(chs);
    setMemRepresentative(chs);
  }

  function handleNext(event) {
    event.preventDefault();
    if (!validateForm()) {
      updateValidationMessages();
      console.log("Messages.....");
        console.log(messages);
	let hasErr = false;
        for (const elm of Object.keys(messages)) {
	  if (messages[elm].n.length > 0) {
            if(!document.getElementById(elm)) continue;
            hasErr = true;
            console.log(elm);
            document.getElementById(elm).scrollIntoView();
          
            break;
          }
        }
        console.log('hasErr....');
	console.log(hasErr);
        if (!hasErr)
        for (const elm of Object.keys(vldNamesByHand)) {
          if (vldNamesByHand[elm].length > 0) {
            if (!document.getElementById(elm)) {
		console.log('couldnot find ' + elm + ', so skipping');
                continue;
	    }
            console.log(elm);
            console.log(vldNamesByHand[elm]);
              if (vldNamesByHand[elm].length > 0) {
                document.getElementById(elm).scrollIntoView();
                hasErr = true;
                break;
	      }
	  }
        }
        //

      if (hasErr) return true;
    }
    console.log('handleOnNext...');
    console.log(event);
    setRefreshCount(refreshCount+1);
    setPage('confirm');
    return false;
  }

  async function handleSubmit(event) {
    event.preventDefault();

    setIsLoading(true);

    try {
      const newUser = await Auth.signUp({
        username: fields.loginId,
        password: fields.password
      });
      setIsLoading(false);
      setNewUser(newUser);
    } catch (e) {
      onError(e);
      setIsLoading(false);
    }
  }

  const createMember = (member) => {
    return API.post('sakurajima', '/members', {
      body: member
    });
  };

  const statusIdString = (mtype, mstatus) => {
  };

  async function handleConfirmationSubmit(event) {
    event.preventDefault();

    setIsLoading(true);
    console.log('handleConfirmationSubmit...');

    try {
      const certifiedDate = fields.certifiedDate;
      const acquiredDate = fields.acquiredDate;

      const m = await createMember({
              admissionRequestDate: today(),
              memType: memType.toString(),
              memStatus: memStatus.toString(),
              familyName: fields.familyName,
              givenName: fields.givenName,
              familyNameKana: fields.familyNameKana,
              givenNameKana: fields.givenNameKana,
              mName: fields.familyName + fields.givenName,
              gender: gender,
              birthDate: fields.birthDate,
              destination: destination,
              affiliationName: fields.affiliationName,
              affiliationDepertment: fields.affiliationDepertment,
              affiliationPosition: fields.affiliationPosition,
              affiliationOccupation: fields.affiliationOccupation,
              affiliationPostalCode: fields.affiliationPostalCode,
              affiliationAddress: fields.affiliationAddress,
              affiliationAddressKana: fields.affiliationAddressKana,
              affiliationTel: fields.affiliationTel,
              affiliationFax: fields.affiliationFax,
              affiliationEmail: fields.affiliationEmail,
              homePostalCode: fields.homePostalCode,
              homeAddress: fields.homeAddress,
              homeAddressKana: fields.homeAddressKana,
              homeTel: fields.homeTel,
              homeFax: fields.homeFax,
              basicDomain: fields.basicDomain,
              expertDomains: expertDomainChecks,
              basicDomainOther: fields.basicDomainOther,
              expertDomainOther: fields.expertDomainOther,
              primaryGames: primaryGames,
              academicHistory: fields.academicHistory,
              graduate: graduate,
              classOfYear: fields.classOfYear,
              expectedToGraduateOfYear: fields.expectedToGraduateOfYear,
              medicalRegistrationNumber: fields.medicalRegistrationNumber,
              certifiedDate: certifiedDate,
              cert1Checks: cert1Checks,
              certifiedNo0: fields.certifiedNo0,
              certifiedDate0: fields.certifiedDate0,
              certifiedNo1: fields.certifiedNo1,
              certifiedDate1: fields.certifiedDate1,
              certifiedNo2: fields.certifiedNo2,
              certifiedDate2: fields.certifiedDate2,
              certifiedNo3: fields.certifiedNo3,
              certifiedDate3: fields.certifiedDate3,
              certifiedNo4: fields.certifiedNo4,
              certifiedDate4: fields.certifiedDate4,
              certifiedNo5: fields.certifiedNo5,
              certifiedDate5: fields.certifiedDate5,
              certifiedNo6: fields.certifiedNo6,
              certifiedDate6: fields.certifiedDate6,
              certifiedNo7: fields.certifiedNo7,
              certifiedDate7: fields.certifiedDate7,
              certifiedNo8: fields.certifiedNo8,
              certifiedDate8: fields.certifiedDate8,
              certifiedNo9: fields.certifiedNo9,
              certifiedDate9: fields.certifiedDate9,
              certifiedNo10: fields.certifiedNo10,
              certifiedDate10: fields.certifiedDate10,
              certified12Text: fields.certified12Text,
              certifiedNo12: fields.certifiedNo12,
              certifiedDate12: fields.certifiedDate12,
              certifiedNo13: fields.certifiedNo13,
              certifiedDate13: fields.certifiedDate13,
              certifiedNo14: fields.certifiedNo14,
              certifiedDate14: fields.certifiedDate14,
              degree: fields.degree,
              certificationNumber: fields.certificationNumber,
              acquiredDate: acquiredDate,
              cert2Checks: cert2Checks,
              recommender: fields.recommender,
              reasonForRecommend: fields.reasonForRecommend,
              recommender1: fields.recommender1,
              reasonForRecommend1: fields.reasonForRecommend1,
              recommender2: fields.recommender2,
              reasonForRecommend2: fields.reasonForRecommend2,
              biography: fields.biography,
              activitiesForTheField: fields.activitiesForTheField,
              papersAndPerformanceHistory: fields.papersAndPerformanceHistory,
              motivationsAndAspirations: fields.motivationsAndAspirations
          });

          console.log(m);
          const name = `${fields.familyName}${fields.givenName} `;
          const b = config.mail.registeredBody.toString().match(/(?:\/\*(?:[\s\S]*?)\*\/)/).pop().replace(/^\/\*/, "").replace(/\*\/$/, "");
        const ba = b.replaceAll('{{name}}', name).replaceAll('{{}}', "\n").replaceAll('{{memLabel}}', (mt == 1 ? '正会員' : ( mt == 14 ? '学生会員' : '准会員'))).replaceAll('{{greetingNotice}}', (mt == 1 ? 'お申込みいただいた内容を確認の上、事務局よりご連絡いたします。' : 'お申込みいただいた内容を確認し、資格審査委員会での基本資格審査の合格後に、事務局よりご連絡いたします。')).split("\n");

          console.log(b.replaceAll('{{name}}', name));
          console.log('mt = ' +  mt);

          let bod = [];
          for (let i in ba) {
            bod.push(ba[i].trim());
          }

          let fromName = '【日本臨床スポーツ医学会】';
          fromName = libmime.encodeWord(fromName, 'Q');
          const dests = [];
          dests.push({
            pk:m.pk,
            familyName:fields.familyName,
            givenName:fields.givenName,
            familyNameKana:fields.familyNameKana,
            givenNameKana:fields.givenNameKana,
            memberId:m.memberId,
            affiliationName:fields.affiliationName,
            affiliationEmail:fields.affiliationEmail,
          });

          const r = await sendMail({
              subject: (mt == 1 ? '正会員' : ( mt == 14 ? '学生会員' : '准会員')) + config.mail.registeredMailSubject,
              from: fromName + ' <' + config.mail.source + '>',
              to: fields.affiliationEmail,
              bcc: config.mail.bcc,
              mailBody:bod.join("\n"),
              enableLog: false,
              fromEmail: config.mail.source,
	      fromName: '【日本臨床スポーツ医学会】',
              dests: dests
          });
          console.log(r);
          if (r.statusCode == 500) {
            console.error(r.statusCode + ':');
            console.error(r.body);
            throw new Error(r.body);
          } else if (r.statusCode != 200) {
            console.error(r.statusCode + ':');
            throw new Error('Eメールを送信中にエラーが発生しました。');
          }

          setPage('complete');
          console.log(m);
    } catch (e) {
      onError(e);
      setIsLoading(false);
    }
    setIsLoading(false);
  }

  const sendMail = (data) => {
    return API.post('sakurajima', '/sendmail', {
      body: data
    });
  };

  function renderCompletionView() {
    return (
      <p><span class="fWB">申込みが完了しました。</span><br/>
                  登録いただいたメールアドレスに確認メールを送信しておりますのでご確認ください。</p>
    );
  }

  function renderPrivacyPolicyForm() {
    return (
      <PrivacyPolicyForm setPage={setPage} setRefreshCount={setRefreshCount}/>
    );
  }

  const back = (event) => { 
      console.log(event.target.id);
      setPage('input');
  };

  function renderConfirmationForm() {
    return (
      <>
        <div id="registration" className="confirm">
          <section>
            { administrativeAttrsConfirm }
            <RegistrationInfoConfirm 
              fields={fields} gender={gender}
              destination={destination}
              viewMode={false}
            />
            <AffiliationInfoConfirm
              fields={fields} 
              viewMode={false}
              mt={mt}
            />
            <HomeInfoConfirm
              fields={fields} 
              viewMode={false}
            />
            { basicDomainInfoConfirm }
            <AcademicHistoryInfoConfirm
              fields={fields} 
              graduate={graduate} 
              viewMode={false} mt={mt}
            />
            {certificationInfoConfirm}
            {certificationInfo2Confirm}
            {recommendersInfoConfirm}
            {recommendersInfo2Confirm}
            {othersInfoConfirm}
        <Form onSubmit={handleConfirmationSubmit}>
        <div className="btn">
          <Button id="prev" active size="lg" active onClick={ back } >
            戻る
          </Button>
          <LoaderButton
            active
            size="lg"
            type="submit"
            id="regist"
            variant="success"
            isLoading={isLoading}
            disabled={!validateConfirmationForm()}
          >
          申込み
          </LoaderButton>
        </div>
        </Form>
	    {/*
      <Form onSubmit={handleConfirmationSubmit}>
        <Form.Group controlId="confirmationCode" size="lg">
          <Form.Label>Confirmation Code</Form.Label>
          <Form.Control
            type="tel"
            onChange={handleFieldChange}
            value={fields.confirmationCode}
          />
          <Form.Text muted>Please check your Login ID for the code.</Form.Text>
        </Form.Group>
        <Button id="prev" active size="lg" active onClick={ back } >
          戻る
        </Button>
        <LoaderButton
          active
          size="lg"
          type="submit"
          variant="success"
          isLoading={isLoading}
          disabled={!validateConfirmationForm()}
        >
          Verify
        </LoaderButton>
      </Form>
	     */}
          </section>
        </div>
      </>
    );
  }

  // A Pane
  const administrativeAttrsForm = opType == 0 ? <AdministrativeAttrsForm fields={fields} handleFieldChange={handleFieldChange} memStatus={memStatus} setMemStatus={setMemStatus} memType={memType} setMemType={setMemType}　memClass={memClass} setMemClass={setMemClass} memPost={memPost} setMemPost={setMemPost} handleMemPostChange={handleMemPostChange} memCommittee={memCommittee} setMemCommittee={setMemCommittee} handleMemCommitteeChange={handleMemCommitteeChange} memPaymentMethod={memPaymentMethod} setMemPaymentMethod={setMemPaymentMethod} memRepresentative={memRepresentative} setMemRepresentative={setMemRepresentative} handleMemRepresentativeChange={handleMemRepresentativeChange} messages={messages} page="page" isEdit={false}/> : <></>;
  const administrativeAttrsConfirm = opType == 0 ? <AdministrativeAttrsConfirm member={null} /> : <></>;

  // E Pane
    const basicDomainInfoForm = opType == 1 || opType == 0 ? <BasicDomainInfoForm fields={fields} handleFieldChange={handleFieldChange} basicDomainOtherMessage={basicDomainOtherMessage} expertDomainChecks={expertDomainChecks} handleExpertDomainChecksChange={handleExpertDomainChecksChange} expertDomainChecksMessage={expertDomainChecksMessage} expertDomainOtherMessage={expertDomainOtherMessage} primaryGames={primaryGames} handlePrimaryGamesChange={handlePrimaryGamesChange} primaryGamesMessage={primaryGamesMessage} messages={messages} page="page" isEdit={false}/> : <></>;
  const basicDomainInfoConfirm = opType == 1 || opType == 0 ? <BasicDomainInfoConfirm fields={fields} expertDomainChecks={expertDomainChecks} primaryGames={primaryGames}/> : <></>;

    const expectedToGraduate = opType == 10 ? (
      <>
        <h3>卒業予定</h3>
        <dl>
        </dl>
    </>) : <></>;
  // G,H Panes
  const certificationInfoForm = opType == 1 || opType == 0 ? <CertificationInfoForm fields={fields} handleFieldChange={handleFieldChange} 
                                  cert1Checks={cert1Checks} handleCert1ChecksChange={handleCert1ChecksChange}
                                  cert1ChecksMessage={ cert1ChecksMessage }
                                  messages={messages} page="page" isEdit={false}
        /> : <></>;
  const certificationInfoConfirm = opType == 1 || opType == 0 ? <CertificationInfoConfirm fields={fields} 
                                     cert1Checks={cert1Checks}
        /> : <></>;

  // I Pane
  const certificationInfo2Form = opType == 0 || opType == 2 || opType === 3 || opType === 4 ? <CertificationInfo2FormV2
                                     fields={fields} handleFieldChange={handleFieldChange}
                                     cert2Checks={cert2Checks} handleCert2ChecksChange={handleCert2ChecksChange}
                                     cert2ChecksMessage={ cert2ChecksMessage }
                                     messages={messages} page="page" isEdit={false}/> : <></>;
  const certificationInfo2Confirm = opType == 0 || opType == 2 || opType === 3 || opType === 4 ? <CertificationInfo2ConfirmV2 fields={fields} 
                                     cert2Checks={cert2Checks} /> : <></>;


  // J Pane
  const recommendersInfoForm = opType == 0 || opType == 2 || opType == 4 || opType == 10 ? <RecommendersInfoForm fields={fields} handleFieldChange={handleFieldChange} messages={messages} page="page" isEdit={false}/> : <></>;
  const recommendersInfoConfirm = opType === 0 || opType == 2 || opType === 4 || opType == 10 ? <RecommendersInfoConfirm fields={fields} /> : <></>;

  // K Pane
    const recommendersInfo2Form = (opType === 0 || opType === 4) ? <RecommendersInfo2Form fields={fields} handleFieldChange={handleFieldChange} messages={messages} page="page" isEdit={false}/> : <></>;
    const recommendersInfo2Confirm = (opType === 0 || opType === 4) ? <RecommendersInfo2Confirm fields={fields} /> : <></>;

  // L Pane
  const othersInfoForm = opType == 0 || opType == 2 || opType == 4 || opType == 10 ? <OthersInfoForm fields={fields} handleFieldChange={handleFieldChange} messages={messages} page="page" /> : <></>;
  const othersInfoConfirm = opType == 0 || opType == 2 || opType == 4 || opType == 10 ? <OthersInfoConfirm fields={fields} /> : <></>;

  // M Pane
  const membersInfo = opType === 0 ? <MembersInfo fields={fields} handleFieldChange={handleFieldChange} messages={messages} page="page" /> : <></>;

  function renderForm() {
    return (
        <>
      <section>
      <Form onSubmit={handleNext}>
        <div id="registration" className="form">
          <div className="inner">
            {administrativeAttrsForm}
            <RegistrationInfoForm isAdmin={isAdmin} fields={fields} handleFieldChange={handleFieldChange}
               gender={gender} handleSetGender={handleSetGender} genderMessage={genderMessage} 
               destination={destination} handleSetDestination={handleSetDestination} destinationMessage={destinationMessage} 
               messages={messages}  page="page" isEdit={false}
            />
            <AffiliationInfoForm fields={fields} handleFieldChange={handleFieldChange} emailMismatchMessage={emailMismatchMessage}  messages={messages} page="page" isEdit={false} mt={mt}/>
            <HomeInfoForm fields={fields} handleFieldChange={handleFieldChange} messages={messages} page="page" isEdit={false} />
            {basicDomainInfoForm}
            <AcademicHistoryInfoForm fields={fields} handleFieldChange={handleFieldChange}
              messages={messages} page="page"
              graduate={graduate} handleSetGraduate={handleSetGraduate} graduateMessage={graduateMessage} 
              isEdit={false} mt={mt}
            />
            {certificationInfoForm}
            {certificationInfo2Form}
            {recommendersInfoForm}
            {recommendersInfo2Form}
            {othersInfoForm}
            {membersInfo}

            {/*
        <Form.Group controlId="loginId" size="lg">
          <Form.Label>Login ID</Form.Label>
          <Form.Control
            type="test"
            vale={fields.loginId}
            onChange={handleFieldChange}
          />
        </Form.Group>
        <Form.Group controlId="password" size="lg">
          <Form.Label>Password</Form.Label>
          <Form.Control
            type="password"
            value={fields.password}
            onChange={handleFieldChange}
          />
        </Form.Group>
        <Form.Group controlId="confirmPassword" size="lg">
          <Form.Label>Confirm Password</Form.Label>
          <Form.Control
            type="password"
            onChange={handleFieldChange}
            value={fields.confirmPassword}
          />
        </Form.Group>
             */}
        <LoaderButton
          block
          size="lg"
          type="submit"
          variant="success"
          isLoading={isLoading}
          id="confirm"
        >
          次へ
        </LoaderButton>
      </div>
          </div>
        </Form>
        </section>
        <ScrollToTop/>
      </>
    );
  }

  return (
    <div className="Signup">
      <main>
        <h1 id="page_title">入会　{memberTypeLabel} </h1>
      <div className="container">
        <div id="sub_page">
          {page === "pp" ? renderPrivacyPolicyForm() : (page === "confirm" ? renderConfirmationForm() :  ( page === "complete" ? renderCompletionView() :  renderForm())) }
        </div>
      </div>
      </main>
    </div>
  );
}
